import { makeObservable, observable, flow, action, computed } from "mobx";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import { ComplianceConfigurationKeys } from "@/areas/compliance/constants/configurationKeys";

export default class ComplianceConfigurationStore {
  loading = false;
  loaded = false;
  itemsByKey = {};
  error = null;

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      loaded: observable,
      itemsByKey: observable.ref,
      error: observable,
      load: flow,
      consume: action,
      segregationOfDuties: computed,
      sodPreventResolverFromClosing: computed,
      sodPreventResolverFromReopening: computed,
    });

    this.parentStore = parentStore;
  }

  *load() {
    try {
      this.error = null;
      this.loading = true;
      const response = yield api.get(ApiRoutes.forComplianceConfigurations());
      this.consume(response.data?.items ?? []);
      this.loaded = true;
      return { success: true };
    } catch (e) {
      this.error = e;
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }

  consume(items) {
    const next = {};
    for (const item of items) {
      next[item.key] = item;
    }
    this.itemsByKey = next;
  }

  getValue(key) {
    return this.itemsByKey[key]?.value;
  }

  get segregationOfDuties() {
    const raw = this.getValue(ComplianceConfigurationKeys.SegregationOfDuties);
    return {
      preventResolverFromClosing: raw?.preventResolverFromClosing === true,
      preventResolverFromReopening: raw?.preventResolverFromReopening === true,
    };
  }

  get sodPreventResolverFromClosing() {
    return this.segregationOfDuties.preventResolverFromClosing;
  }

  get sodPreventResolverFromReopening() {
    return this.segregationOfDuties.preventResolverFromReopening;
  }
}
